import React from "react";

export default function PrintCommendationCer({ object, commendation }) {
  const description = commendation?.description;
  const employeeName = `${object?.Firstname || ""} ${
    object?.Middlename || ""
  } ${object?.surname}`;
  const position = object?.position?.position_title;
  return (
    <div
      style={{
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        alignItems: "center",
        position: "relative",
        // marginLeft: "-5px",
        // marginTop: "-10px",
      }}
    >
      <img
        src="/commendationTemp.png"
        alt="template"
        style={{
          maxWidth: "100%",
          maxHeight: "100%",
          objectFit: "contain",
        }}
      />
      <div
        style={{
          position: "absolute",
          //   border: "1px solid",
          textAlign: "center",
          top: "20rem",
        }}
      >
        <div
          style={{
            color: "#a0650f",
            fontFamily: "Cormorant Garamond",
          }}
        >
          <h1 style={{ height: "1rem" }}>{employeeName}</h1>
          <h3>{position}</h3>
        </div>
        <div
          style={{
            paddingLeft: "10rem",
            paddingRight: "10rem",
            fontFamily: "Montserrat",
          }}
        >
          {description?.split(".").map((sentence, index) => (
            <React.Fragment key={index}>
              {`${sentence.trim()}.`}
              {index < description?.split(".").length - 1 && (
                <>
                  <br />
                  <br />
                </>
              )}
            </React.Fragment>
          ))}
        </div>
      </div>
    </div>
  );
}
